import { constants } from 'constants.mjs';

let data = {
  title: constants.orgName,
  description: constants.orgDesc,
  root: 'https://komodoplatform.com',
  siteName: 'komodoplatform.com',
  generator: 'Nextjs',
  language: 'en-US',
  twitter: '@KomodoPlatform',
  komodoPlatformHome: 'https://komodoplatform.com/en/',
  socialUnfurlImage: '',
  defaultEmail: constants.helloEmail,
  gtmId: '',
  logo: '',
  tag: 'komodo',
  webDEXlink: 'https://app.komodoplatform.com/',
  swapWidgetUrl: 'https://komodo-wallet-swap-widget.web.app/', //TODO: update to kp.com version
  downloadsPage: '/en/wallet/',
  downloadURL: 'https://github.com/KomodoPlatform/komodo-wallet-desktop/releases',
  apiUrl: 'https://stats-api.atomicdex.io/api/v1/',
  mobileGuidesLink: '/en/docs/komodo-wallet/mobile/',
  desktopGuidesLink: '/en/docs/komodo-wallet/desktop/',
  helloEmail: constants.helloEmail,
  social: constants.socialLinks,
  env: {},
};
if (process.env.CFP == 'yes') {
  data.root = '';
  data.env.CFP = 'yes';
}
if (process.env.NODE_ENV === 'production') {
  data.env.PRODUCTION = 'yes';
}
export const siteData = data;
